/** @todo put into shared folder to be use with play and teach */
import { initializeApp } from "firebase/app";
import { doc, getFirestore, onSnapshot, updateDoc } from "firebase/firestore";

const firebaseConfigs = {
  production: {
    apiKey: "AIzaSyB42rooB_-fmh5u9u1eU_eksi2LmkqUfwo",
    authDomain: "the-rewriters.firebaseapp.com",
    projectId: "the-rewriters",
    storageBucket: "the-rewriters.firebasestorage.app",
    messagingSenderId: "1051087931996",
    appId: "1:1051087931996:web:7f4b02aa50a1faff797499",
  },
  qa: {
    apiKey: "AIzaSyCSb71BhXBkKuqI5lfKfeZNPIG9MHOCois",
    authDomain: "rewriters-qa.firebaseapp.com",
    projectId: "rewriters-qa",
    storageBucket: "rewriters-qa.firebasestorage.app",
    messagingSenderId: "865230853954",
    appId: "1:865230853954:web:1cc0907ca75a12e706dadb",
  },
  dev: {
    apiKey: "AIzaSyDJvdd8rtWNydRSLkgVg1dgSyn3MTpo-pk",
    authDomain: "biycr-62aee.firebaseapp.com",
    projectId: "biycr-62aee",
    storageBucket: "biycr-62aee.firebasestorage.app",
    messagingSenderId: "219044721669",
    appId: "1:219044721669:web:d819c327efce4e579b186c",
  },
};

const app = initializeApp(
  firebaseConfigs[process.env.REACT_APP_DEPLOY] ?? firebaseConfigs.dev
);
const db = getFirestore(app);

export function updateFirestoreDoc(collectionId, docId, data) {
  return updateDoc(doc(db, collectionId, docId), data).catch((error) =>
    console.error(error)
  );
}

export function getDocSnapshot(collectionId, docId, callback) {
  return onSnapshot(
    doc(db, collectionId, docId),
    (snapshot) => callback?.(snapshot),
    (error) => console.error(error)
  );
}
